import React from 'react';

const CircleQuestionMarkSvg = ({ width, height, color = '#696969' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="M9.672 9.6a2.4 2.4 0 0 1 4.664.8c0 1.6-2.4 2.4-2.4 2.4M12 16h.008M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
    />
  </svg>
);

export default CircleQuestionMarkSvg;
